import React from "react";
import { SITE } from "../config/siteConfig";
import { HeadsetIcon } from "./icons";

export function Logo() {
  return (
    <a href="/" className="logo" aria-label={SITE.brandName + " - inicio"}>
      <span className="logo-text">
        <b>{SITE.logoTop}</b>
        <i>{SITE.logoBottom}</i>
      </span>
      <HeadsetIcon />
    </a>
  );
}
